import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Tooltip,
  InputAdornment,
  IconButton,
  Box,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const names = [
  {
    key: "inscrits",
    label: "Bénévoles validés",
    color: "#C6EDC3", // Vert
    default: true,
  },
  {
    key: "aFinaliser",
    label: "Bénévoles à finaliser (pré-validés)",
    color: "#FFF2CD", // Jaune
  },
  {
    key: "aTraiter",
    label: "Bénévoles à traiter",
    color: "#FFC7BA", // Rouge
  },
  {
    key: "dispoRestantes",
    label: "Disponibilités restantes des bénévoles à finaliser et validés",
    color: "none", // Pas de couleur, affichera un +
  },
];

const menuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
};

function MultipleSelect({ filtersOptions, setFiltersOptions }) {
  useEffect(() => {
    const defaultFilters = names
      .filter((filter) => filter.default)
      .reduce((acc, filter) => {
        acc[filter.key] = true;
        return acc;
      }, {});

    setFiltersOptions((prevFilters) => ({
      ...prevFilters,
      ...defaultFilters,
    }));
  }, [setFiltersOptions]);

  const handleChange = (event) => {
    const { value } = event.target;
    const newFiltersOptions = { ...filtersOptions };
    names.forEach((filter) => {
      if (!filter.default) {
        newFiltersOptions[filter.key] = value.includes(filter.label);
      }
    });
    setFiltersOptions(newFiltersOptions);
  };

  const selectedFilters = names
    .filter((name) => filtersOptions[name.key])
    .map((name) => name.label);

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <InputLabel id="multiple-checkbox-label">Filtres</InputLabel>
      <Select
        labelId="multiple-checkbox-label"
        id="multiple-checkbox"
        multiple
        displayEmpty
        value={selectedFilters}
        onChange={handleChange}
        MenuProps={menuProps}
        input={
          <OutlinedInput
            label="Filtres"
            startAdornment={
              <InputAdornment position="start">
                <Tooltip title="Seules les disponibilités des bénévoles validés (cases vertes du tableau) sont pris en compte pour le calcul du nombre total de bénévoles.">
                  <IconButton size="small">
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            }
          />
        }
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <em>Aucun filtre sélectionné</em>;
          }
          return selected.join(", ");
        }}
      >
        {names.map((filter) => (
          <MenuItem
            key={filter.key}
            value={filter.label}
            disabled={filter.default}
            onClick={(e) => {
              if (filter.default) e.stopPropagation();
            }}
            style={{
              backgroundColor: filter.default ? "#f0f0f0" : "inherit",
              pointerEvents: filter.default ? "none" : "auto",
            }}
          >
            <Checkbox
              checked={selectedFilters.indexOf(filter.label) > -1}
              disabled={filter.default}
            />
            <ListItemText primary={filter.label} />
            {filter.color !== "none" ? (
              <Box
                component="span"
                sx={{
                  width: 24,
                  height: 24,
                  backgroundColor: filter.color,
                  border: "1px solid #000",
                  marginLeft: 16,
                  borderRadius: "20%",
                }}
              />
            ) : (
              <Box
                component="span"
                sx={{
                  width: 24,
                  height: 24,
                  backgroundColor: "#f1f1f1",
                  border: "1px solid #000",
                  marginLeft: 16,
                  borderRadius: "20%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  fontSize: 16,
                }}
              >
                +
              </Box>
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultipleSelect;
